<template>
  <div id="app">
    <transition name="menu-transition">
      <Menu v-if="showMenu" class="menu-bar" v-on:close="showMenu = false" />
    </transition>
    <transition name="hidden-div-transition">
      <div @click="showMenu = false" class="hidden-div" v-if="showMenu"></div>
    </transition>
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 100 150"
      style="enable-background: new 0 0 100 150; width: 30px; height: 30px"
      xml:space="preserve"
      class="logo"
      @click="scrollToTop"
    >
      <g>
        <path class="st0" d="M36.23,69.24l29.79-44.43c-6.77.26-13.9,1.24-21.39,2.93-7.49,1.69-13.9,3.5-19.24,5.42-5.34,1.92-10.11,3.74-14.31,5.47-4.2,1.73-7.21,2.95-9.03,3.66-.46,0-.91-.16-1.37-.49-.46-.33-.68-.72-.68-1.17,0-.52,1.51-3.71,4.54-9.57s6.59-12.14,10.69-18.85C38.02,4.07,58.14,0,75.59,0c20.18,0,34.18,4.3,41.99,12.89,2.8,3,4.96,6.69,6.49,11.08,1.53,4.39,2.29,8.74,2.29,13.04,0,9.77-2.04,18.64-6.1,26.61-4.07,7.98-9.88,14.89-17.43,20.75-7.55,5.86-16.44,10.34-26.66,13.43-10.22,3.09-21.42,4.64-33.59,4.64-2.15,0-6.54-.39-13.18-1.17l-8.79,16.02c.91,1.37,1.37,2.48,1.37,3.32,0,2.02-.46,3.71-1.37,5.08-1.3,1.95-3.03,4.52-5.18,7.71-2.15,3.19-3.6,5.31-4.35,6.35-.75,1.04-1.6,1.95-2.54,2.73-.94.78-1.87,1.17-2.78,1.17-1.89,0-3.09-.57-3.61-1.71-.52-1.14-.78-2.72-.78-4.74,0-2.87,1.42-7.41,4.25-13.62s7.11-14.47,12.84-24.76c-3.06-1.17-5.44-2.7-7.13-4.59-1.69-1.89-2.54-3.74-2.54-5.57,0-4.04,2.31-7.78,6.93-11.23,4.62-3.45,11.46-6.18,20.51-8.2ZM46.39,71.88l-5.57,9.38c2.47.13,4.67.26,6.59.39,1.92.13,3.53.2,4.83.2,11.39,0,21.27-1.53,29.64-4.59,8.36-3.06,15.01-6.85,19.92-11.38,4.92-4.52,8.48-9.07,10.69-13.62,2.21-4.56,3.32-8.36,3.32-11.43,0-4.23-1.69-7.55-5.08-9.96-3.39-2.41-8.25-4.05-14.6-4.93s-14.54-1.32-24.56-1.32c.13.72.2,1.6.2,2.64,0,3.39-1.79,7.85-5.37,13.38l-16.99,26.66,12.79-1.46c1.04,0,1.56.49,1.56,1.46,0,.85-.85,1.43-2.54,1.76l-14.84,2.83Z"/>
      </g>
    </svg>

    <Home id="home" class="section" />
    <Me id="me" class="section" />
    <Work
      id="work"
      v-on:emitImage="[(showImage = true), imagePreview($event)]"
    />
    <FindMe id="find-me" />
    <div class="ocean">
      <div class="wave"></div>
    </div>
    <FooterCurve class="footer" />
    <transition name="image-preview-transititon">
      <div
        v-if="showImage"
        class="image-preview-container"
        @click="[(showImage = false), (previewImageUrl = '')]"
      >
        <img :src="previewImageUrl" class="image-preview" />
      </div>
    </transition>
  </div>
</template>

<script>
import Home from "./section/Home";
import Me from "./section/Me";
import Work from "./section/Work";
import FindMe from "./section/FindMe";
import FooterCurve from "./section/FooterCurve";

export default {
  name: "App",
  components: { Home, Me, FindMe, FooterCurve, Work },
  data() {
    return {
      showMenu: false,
      showImage: false,
      previewImageUrl: "",
      previewImageTitle: "",
    };
  },
  methods: {
    scrollToTop() {
      document.getElementById("app").scrollIntoView({ behavior: "smooth" });
    },
    imagePreview(e, f) {
      this.previewImageUrl = e;
      this.previewImageTitle = f;
    },
  },
  metaInfo: {
    title: "Portfolio",
    meta: [
      {
        name: "theme-color",
        content: "#59ff9c",
      },
      {
        name: "description",
        content: "Portfolio website of Liam Cornu",
      },
    ],
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;700;900&family=Source+Sans+Pro:wght@400;600;700&display=swap");
* {
  box-sizing: border-box;
  font-family: "Roboto", sans-serif;
}
body {
  margin: 0;
  padding: 0;
  background-color: #1c1c1c;
  color: white;
  position: relative;
  overflow-x: hidden;
  scroll-behavior: smooth;
}
.logo,
.menu {
  z-index: 2;
  margin: 2em;
  width: 30px;
  cursor: pointer;
  position: fixed;
}
.logo {
  top: 0;
  left: 0;
}
.image-preview {
  max-height: 95%;
  max-width: 95%;
  border-radius: 40px;
}
.image-preview-container {
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(4px);
  z-index: 100;
}
.image-preview-transititon-enter-active,
.image-preview-transiiton-leave-active {
  transition: all 0.3s ease;
}
.image-preview-transititon-enter,
.image-preview-transititon-leave-to {
  opacity: 0;
}
.menu {
  top: 0;
  right: 0;
}
.nav {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 2em;
  position: fixed;
}
.menu-bar {
  z-index: 10;
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
}
.hidden-div {
  backdrop-filter: blur(3px);
  z-index: 5;
  position: fixed;
  width: 100%;
  left: 0;
  top: 0;
  height: 100vh;
}
.menu-transition-enter-active,
.menu-transition-leave-active {
  transition: all 0.3s ease-out;
}
.menu-transition-enter,
.menu-transition-leave-to {
  transform: translateX(80vw);
}
h1 {
  font-size: 72px;
}
.hidden-div-transition-active,
.hidden-div-transition-leave-active {
  transition: all 0.3s ease;
}
.hidden-div-transition-enter,
.hidden-div-transition-leave-to {
  opacity: 0;
}

.section {
  width: 100%;
  height: 100%;
  padding: 50px;
}
.footer {
  display: flex;
  justify-content: center;
  background-color: white;
}

.ocean {
  height: 100px;
  width: 100%;
  position: absolute;
  bottom: 29vh;
  left: 0;
}

.wave {
  background: url("./assets/pattern/wave.svg") repeat-x;
  position: absolute;
  bottom: 0;
  width: 6400px;
  height: 198px;
  animation: wave 30s cubic-bezier(0.36, 0.45, 0.63, 0.53) infinite;
  transform: translate3d(0, 0, 0);
}

@keyframes wave {
  0% {
    margin-left: 0;
  }
  100% {
    margin-left: -1600px;
  }
}

.st0 {
  fill: #ffffff;
  transition: 0.4s ease-in;
}

.logo:hover .st0 {
  fill: #59ff9c;
}
.st1 {
  fill: none;
}
.st2 {
  transition: 0.4s ease-in;
  fill: #ffffff;
}

.menu:hover .st2 {
  fill: #59ff9c;
}

@media (max-width: 700px) {
  .section {
    height: 100%;
  }
  .ocean,
  .wave {
    display: none;
  }
}
</style>
